import icon from 'vue-svgicon';

icon.register({
    'regular/maps': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M16.307 2.838a1.5 1.5 0 0 0-1.114 0L8.807 5.393a1.5 1.5 0 0 1-1.114 0L1.779 3.027a.75.75 0 0 0-1.029.7V18.1a1.5 1.5 0 0 0 .943 1.393l6 2.4a1.5 1.5 0 0 0 1.114 0l6.386-2.555a1.5 1.5 0 0 1 1.114 0l5.914 2.362a.75.75 0 0 0 1.029-.7V6.631a1.5 1.5 0 0 0-.943-1.393zM8.25 5.5V22M15.75 2.731v16.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
